<template>
  <div ref="dropdown" class="language-dropdown">
    <button
        class="language-dropdown__btn"
        :class="{active: isActive}"
        style="margin-left: auto;"
        ref="dropdownButton"
        @click="handleLanguageDropdownClick"
        @keydown.esc="closeLanguageDropdown"
    >
      <span class="language-dropdown__text" v-if="!languageChosen">{{$t('selectLanguage')}}</span>
      <span class="language-dropdown__text" v-else>{{selectedLanguage}}</span>
      <div class="icon language-dropdown__text"></div>
    </button>

    <div @blur="onBlur" ref="dropdownList" tabindex="0">
      <ul
          :class="{'w-100': !languageChosen}"
          class="language-dropdown__list"
          v-if="languageDropdownVisible"
      >
        <li v-if="!languageChosen">
          <p class="text ph5">› {{$t('selectLanguage')}}</p>
        </li>

        <li v-for="language in languages" :key="language.language">
          <a
              @click="handleClose(language.language)"
              :id="language.title"
              class="link"
              :class="{'language-selected': (getLanguage() === language.language)}"
              href="#"
          >{{language.title}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getLanguage, getPathNameFromRouteName, findElementInChildren, setCookie, getCookie } from '@/utils/common';

export default {
  data() {
    return {
      isActive: false,
      languageDropdownVisible: false,
      languages: [
        { flag: 'us', language: 'en-us', title: 'English' },
        { flag: 'fr', language: 'fr', title: 'French' },
        { flag: 'it', language: 'it', title: 'Italian' },
        { flag: 'ja', language: 'ja', title: 'Japanese' },
        { flag: 'pt', language: 'pt', title: 'Portuguese' },
        { flag: 'es', language: 'es', title: 'Spanish' },
        { flag: 'ms', language: 'ms', title: 'Malay' }
      ],
      languageChosen: getCookie('lng_chosen')
    };
  },
  computed: {
    selectedLanguage() {
      let selectedLanguageObject = this.languages.find(language => {
        return getLanguage() === language.language;
      });
      return selectedLanguageObject.title;
    }
  },
  methods: {
    ...mapActions(['changeLanguage']),
    getLanguage: getLanguage,
    handleClose(language) {
      let originalLocation = window.location.href;
      /* eslint-disable no-useless-escape */
      let regex = new RegExp(`\/${getLanguage()}`, 'g');
      this.changeLanguage(language).then(() => {
        setCookie('lng_chosen', true);
        let redirectPathName = `${getPathNameFromRouteName(this.$route.name, this.$router)}${window.location.search}`;
        const queryHash = originalLocation.match(new RegExp('query' + '=([^&]*)'));

        if (queryHash) {
          redirectPathName = `${redirectPathName}#query=${decodeURIComponent(queryHash[1])}`;
        }
        if (redirectPathName) {
          window.location.href = `/${language}/${redirectPathName.replace(/ /g, '-')}`;
        } else {
          window.location.href = originalLocation.replace(regex, `/${language}`);
        }
      });
    },
    toggleOpenState() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
      this.isActive = !this.isActive;
    },
    handleLanguageDropdownClick(e) {
      this.toggleOpenState();
      if (this.languageDropdownVisible) {
        this.$refs.dropdownList.focus();
      }
    },
    closeLanguageDropdown() {
      this.languageDropdownVisible = false;
      this.isActive = false;
    },
    onBlur(e) {
      const children = Array.from(this.$refs.dropdownList.children);
      const target = e.relatedTarget;

      const found = children.find(child => findElementInChildren(child, target));
      if (!found && target !== this.$refs.dropdownButton) {
        this.languageDropdownVisible = false;
        this.isActive = false;
        this.$refs.dropdownButton.blur();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.language-dropdown {
  position: relative;
  z-index: 2;
}
.language-dropdown__btn {
  font-family: Segoe UI, Arial, sans-serif;
  border: 1px solid #dedede;
  color: #333;
  padding: 8px 15px 8px 20px;
  background: #F5F5F7;
  border-radius: 30px;
  font-weight: 700;
  font-size: 14px;
  .language-dropdown__text {
    display: inline-block;
    vertical-align: top;
    &.icon {
      margin: 6px 0 0 15px;
      border: 6px solid transparent;
      border-top: 8px solid #333;
    }
  }
  &:hover, &:active, &.active {
    background: #fff;
    cursor: pointer;
  }
}
.language-dropdown__list {
  z-index: 2;
  position: absolute;
  right: 0;
  left: 0;
  text-align: left;
  background-color: #ffffff;
  text-decoration: none;
  border: 1px solid #ffffff;
  overflow: hidden;
  padding: 14px 18px;
  margin: 10px 0 0;
  border-radius: 20px;
  animation: bounce 0.6s ease-out;
  list-style: none;
  .text {
    margin: 0;
    padding: 0 0 5px;
    font-weight: 400;
    color: #333;
    display: block;
    font-size: 12px;
  }
  .link {
    padding: 0 0 5px;
    color: #333;
    font-weight: 400;
    font-size: 12px;
    display: block;
  }
  .link:hover {
    font-weight: 600;
  }
}
.language-selected {
  font-weight: 600;
}
</style>
